/** MCP Apps sandbox proxy protocol constants (keep in sync with public/mcp-sandbox-proxy.js). */

export const SANDBOX_RESOURCE_READY_NOTIFICATION =
  'ui/notifications/sandbox-resource-ready' as const;

export const SANDBOX_PROXY_READY_NOTIFICATION = 'ui/notifications/sandbox-proxy-ready' as const;

export const DEFAULT_SANDBOX_ATTRIBUTE =
  'allow-scripts allow-same-origin allow-forms allow-popups' as const;

export const ALLOWED_SANDBOX_TOKENS = [
  'allow-downloads',
  'allow-forms',
  'allow-modals',
  'allow-orientation-lock',
  'allow-pointer-lock',
  'allow-popups',
  'allow-popups-to-escape-sandbox',
  'allow-presentation',
  'allow-same-origin',
  'allow-scripts',
  'allow-top-navigation-by-user-activation',
] as const;

export type SandboxResourceReadyParams = {
  html?: string;
  sandbox?: string;
  permissions?: Record<string, unknown>;
};

export type SandboxRpcMessage = {
  jsonrpc?: string;
  method: string;
  params?: SandboxResourceReadyParams | Record<string, unknown>;
};

export type SandboxProxyReadyMessage = {
  jsonrpc: '2.0';
  method: typeof SANDBOX_PROXY_READY_NOTIFICATION;
  params: Record<string, never>;
};

export const isSandboxResourceReadyMessage = (
  data: unknown,
): data is SandboxRpcMessage & { method: typeof SANDBOX_RESOURCE_READY_NOTIFICATION } => {
  if (!data || typeof data !== 'object') {
    return false;
  }
  const message = data as SandboxRpcMessage;
  return message.method === SANDBOX_RESOURCE_READY_NOTIFICATION;
};
